import styled from "styled-components";
import Tiles from "./Tiles";

const BoardDiv = styled.div`
  width: 100%;
  max-width: 500px;
  height: 500px;
  background-image: ${props => props.theme.gradient};
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 10px;
  box-shadow: 8px 8px 10px rgb(165, 165, 165);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.8em;
  padding: 0.8em;

  @media only screen and (max-width: 412px) {
      height: 300px;
  }
`;

export default function Board({ pics, state, clicked }) {
  return (
    <BoardDiv>
      <Tiles svgNo={pics[0]} index={0} state={state[0]} click={clicked} />
      <Tiles svgNo={pics[1]} index={1} state={state[1]} click={clicked} />
      <Tiles svgNo={pics[2]} index={2} state={state[2]} click={clicked} />
      <Tiles svgNo={pics[3]} index={3} state={state[3]} click={clicked} />
      <Tiles svgNo={pics[4]} index={4} state={state[4]} click={clicked} />
      <Tiles svgNo={pics[5]} index={5} state={state[5]} click={clicked} />
      <Tiles svgNo={pics[6]} index={6} state={state[6]} click={clicked} />
      <Tiles svgNo={pics[7]} index={7} state={state[7]} click={clicked} />
      <Tiles svgNo={pics[8]} index={8} state={state[8]} click={clicked} />
      <Tiles svgNo={pics[9]} index={9} state={state[9]} click={clicked} />
      <Tiles svgNo={pics[10]} index={10} state={state[10]} click={clicked} />
      <Tiles svgNo={pics[11]} index={11} state={state[11]} click={clicked} />
      <Tiles svgNo={pics[12]} index={12} state={state[12]} click={clicked} />
      <Tiles svgNo={pics[13]} index={13} state={state[13]} click={clicked} />
      <Tiles svgNo={pics[14]} index={14} state={state[14]} click={clicked} />
      <Tiles svgNo={pics[15]} index={15} state={state[15]} click={clicked} />
    </BoardDiv>
  );
}
